var exports = {
  "kL": "x804f0401--dc415a--container",
  "VQ": "x804f0401--dc415a--photo-container",
  "jW": "x804f0401--dc415a--photo",
  "pq": "x804f0401--dc415a--info",
  "DD": "x804f0401--dc415a--title",
  "Yu": "x804f0401--dc415a--dates",
  "hl": "x804f0401--dc415a--address",
};

module.exports = exports;
